import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, IconButton, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button, type DropdownListItem } from '@verantos-dev/shared-components';

import { FilterBySection } from './FilterBySection';
import { GroupBySection } from './GroupBySection';
import { SortBySection } from './SortBySection';
import { useAppSelector, useAppDispatch } from '../../../../../lib/store';
import { selectViewOptionExpanded } from '../../../state/selector';
import { setViewOptionExpanded } from '../../../state/supervisorSlice';

export interface ViewOptionsSectionProps {
  filterOptions: DropdownListItem[];
}

export const ViewOptionsSection = ({ filterOptions }: ViewOptionsSectionProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const viewOptionExpanded = useAppSelector(selectViewOptionExpanded);
  const handleViewOptionExpanded = (value: boolean) => {
    dispatch(setViewOptionExpanded(value));
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        p: theme.spacing(4),
        gap: theme.spacing(2),
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">
          {formatMessage({ id: 'workspaceCommon.sidebar.viewOptions.title' })}
        </Typography>
        {viewOptionExpanded ? (
          <Button
            variant="text"
            startIcon={<KeyboardArrowUpIcon sx={{ fontSize: '12px' }} />}
            sx={{ textTransform: 'none', fontSize: '14px' }}
            id="supervisor-view-options-collapse-button"
            displayLabel={formatMessage({
              id: 'workspaceCommon.sidebar.viewOptions.collapseButtonLabel',
            })}
            onClickHandler={() => handleViewOptionExpanded(false)}
          />
        ) : (
          <Button
            variant="text"
            startIcon={<KeyboardArrowDownIcon sx={{ fontSize: '12px' }} />}
            sx={{ textTransform: 'none', fontSize: '14px' }}
            id="supervisor-view-options-expand-button"
            displayLabel={formatMessage({
              id: 'workspaceCommon.sidebar.viewOptions.expandButtonLabel',
            })}
            onClickHandler={() => handleViewOptionExpanded(true)}
          />
        )}
      </Box>
      {viewOptionExpanded && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(6) }}>
          <GroupBySection />
          <SortBySection />
          <FilterBySection filterOptions={filterOptions} />
        </Box>
      )}
    </Box>
  );
};
